export interface HomeViewDataDTO {
    pendingRP: number | null;
    pendingInterconsultations: number | null;
    professional: boolean;
    specialitieslist: string[] | null;
    workerenrollmenttype: string | null;
    workenrollment: string | null;
}

export const defaultHomeViewDataDTO:HomeViewDataDTO = {
    pendingRP: -1,
    pendingInterconsultations:  -1,
    professional: false,
    specialitieslist: [],
    workerenrollmenttype: '',
    workenrollment: '',
}